
import { memo } from "react"
const Candles = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M14.5714 9.42855V14.5714H17.1429V9.42855H14.5714ZM14.1429 8.57141H17.5714C17.6851 8.57141 17.7941 8.61656 17.8745 8.69694C17.9548 8.77731 18 8.88632 18 8.99998V15C18 15.1136 17.9548 15.2227 17.8745 15.303C17.7941 15.3834 17.6851 15.4286 17.5714 15.4286H14.1429C14.0292 15.4286 13.9202 15.3834 13.8398 15.303C13.7594 15.2227 13.7143 15.1136 13.7143 15V8.99998C13.7143 8.88632 13.7594 8.77731 13.8398 8.69694C13.9202 8.61656 14.0292 8.57141 14.1429 8.57141Z"
                fill="currentColor"/>
            <path d="M15.4286 6H16.2857V9H15.4286V6ZM15.4286 15H16.2857V18H15.4286V15Z" fill="currentColor"/>
            <path
                d="M7.71429 6.85714V17.1429H10.2857V6.85714H7.71429ZM7.28572 6H10.7143C10.828 6 10.937 6.04515 11.0173 6.12553C11.0977 6.2059 11.1429 6.31491 11.1429 6.42857V17.5714C11.1429 17.6851 11.0977 17.7941 11.0173 17.8745C10.937 17.9548 10.828 18 10.7143 18H7.28572C7.17205 18 7.06305 17.9548 6.98267 17.8745C6.9023 17.7941 6.85715 17.6851 6.85715 17.5714V6.42857C6.85715 6.31491 6.9023 6.2059 6.98267 6.12553C7.06305 6.04515 7.17205 6 7.28572 6Z"
                fill="currentColor"/>
            <path d="M8.57143 3.42859H9.42857V6.42859H8.57143V3.42859ZM8.57143 17.5714H9.42857V20.5714H8.57143V17.5714Z"
                  fill="currentColor"/>
        </svg>
    )
}

export default memo(Candles)